/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { BOTTOM_FADE_IN_CSS } from '@constant/animation';

interface IProps {
  children: React.ReactNode;
  height: string;
  paddingTop?: string;
  backgroundColor?: string;
  boxShadow?: string;
  left?: string;
  right?: string;
  margin?: string;
  position?: 'fixed' | 'absolute' | 'relative';
  // animationKey가 바뀌면 inner를 리마운트해 BOTTOM_FADE_IN을 재실행. 미지정 시 애니메이션 없음.
  animationKey?: string | number;
}

const Wrapper = styled.div<{
  $height: string;
  $paddingTop: string;
  $backgroundColor: string;
  $boxShadow: string;
  $left: string;
  $right: string;
  $margin: string;
  $position: 'fixed' | 'absolute' | 'relative';
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  width: auto;
  flex-shrink: 0;
  position: ${(props) => props.$position};
  ${(props) => props.$position === 'fixed' && `left: ${props.$left}; right: ${props.$right}; bottom: 0; width: 100%;`}
  margin: ${(props) => props.$margin};
  padding-bottom: ${(props) => (props.$position === 'fixed' ? 'var(--sab)' : '0px')};
  padding-top: ${(props) => props.$paddingTop};
  height: ${(props) => (props.$position === 'fixed' ? `calc(${props.$height} + var(--sab))` : props.$height)};
  justify-content: space-around;
  background-color: ${(props) => props.$backgroundColor};
  box-shadow: ${(props) => props.$boxShadow};
`;

const AnimationContainer = styled.div`
  width: 100%;
  height: 100%;
  ${BOTTOM_FADE_IN_CSS}
`;

const BottomContainer: React.FC<IProps> = ({
  children,
  height,
  position = 'fixed',
  left = '0px',
  right = '0px',
  margin = '0',
  paddingTop = '0px',
  backgroundColor = 'transparent',
  boxShadow = 'none',
  animationKey,
}) => {
  return (
    <Wrapper
      $position={position}
      $left={left}
      $right={right}
      $margin={margin}
      $height={height}
      $paddingTop={paddingTop}
      $backgroundColor={backgroundColor}
      $boxShadow={boxShadow}>
      {animationKey !== undefined ? <AnimationContainer key={animationKey}>{children}</AnimationContainer> : children}
    </Wrapper>
  );
};

export default BottomContainer;
